export default Object.freeze({
  EMAIL: 0,
  CALLBACK: 10
})
